// extracted by mini-css-extract-plugin
export default {"editor":"OE9V5","editorDisabled":"Aec23","toolbar":"IxTUS","marks":"ukcOF","blocks":"zvRfe","input":"LflnO"};